export * from './flag'
import { default as Flag } from './flag'

export default Flag
